import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import ImageOne from "../../assets/images/about/SubImage1.JPG";
import ImageTwo from "../../assets/images/about/SubImage2.JPG";
import ImageThree from "../../assets/images/about/SubImage3.JPG";
const useStyles = makeStyles((theme) => ({
  box: {
    width: "100%",
    height: "auto",
    backgroundColor: theme.palette.secondary.main,
    padding: "0 80px",
    paddingTop: "60px",
    marginBottom: "50px",
    [theme.breakpoints.between("lm", "lm")]: {
      paddingTop: "40px",
      padding: "0 45px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 20px",
    },
  },
  boxRow: {
    marginBottom: "30px",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.between("md", "md")]: {
      marginTop: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      flexDirection: "column",
    },
  },
  boxRowRe: {
    marginBottom: "30px",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      flexDirection: "column-reverse",
    },
  },
  content: {
    padding: "20px",
    [theme.breakpoints.between("md", "md")]: {
      padding: "0 20px",
      paddingTop: "5px",
    },
  },
  contentTwo: {
    padding: "30px",
    [theme.breakpoints.between("lm", "lm")]: {
      padding: "0 25px",
      paddingTop: "30px",
    },
  },
  imageOne: {
    maxWidth: "100%",
    maxHeight: "217px",
    width: "auto",
    height: "auto",
    display: "block",
    // verticalAlign: "middle",
    [theme.breakpoints.between("md", "md")]: {
      width: "188px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "334px",
      margin: "auto",
    },
  },
  imageTwo: {
    maxHeight: "188px",
    width: "auto",
    height: "auto",
    display: "block",
    // verticalAlign: "middle",
    marginBottom: "30px",
    maxWidth: "250px",
    [theme.breakpoints.between("md", "md")]: {
      width: "163px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "289px",
      margin: "auto",
      paddingBottom: "20px",
    },
  },
  imageColumn: {
    width: "100%",
    marginTop: "30px",
    [theme.breakpoints.between("md", "md")]: {
      marginLeft: "15px",
    },
  },
  paragraph: {
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: ".75rem",
      letterSpacing: ".64px",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: ".625rem",
    },
    [theme.breakpoints.down("s")]: {
      fontSize: ".875rem",
    },
  },
}));

export default function FourthBox() {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <div className={classes.boxRow}>
        <div className={classes.content}>
          <Typography color="primary" gutterBottom variant="h2">
            大国ファームの挑戦{" "}
          </Typography>
          <Typography
            gutterBottom
            className={classes.paragraph}
            paragraph={true}
          >
            植物が本来持っている自然の力を最大限に引き出すため、無農薬で化学肥料を使用しない農法を実践していきます。
          </Typography>{" "}
          <Typography
            gutterBottom
            className={classes.paragraph}
            paragraph={true}
          >
            昔ながらのおいしい野菜やくだものをみなさまにお届けするため、大国ファームは挑戦し続けます。{" "}
          </Typography>
        </div>
        <img src={ImageOne} className={classes.imageOne} alt="hand vegetable" />
      </div>{" "}
      <div className={classes.boxRowRe}>
        <div className={classes.imageColumn}>
          <img src={ImageTwo} className={classes.imageTwo} alt="vegetable" />
          <img src={ImageThree} className={classes.imageTwo} alt="vegetable" />
        </div>
        <div className={classes.contentTwo}>
          <Typography color="primary" gutterBottom variant="h2">
            化学肥料・除草剤などは一切使わず 土壌殺菌も行わせない農法
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            paragraph={true}
          >
            化学肥料・除草剤などは一切使わず土壌殺菌も行わない農法で、金剛山・葛城山を仰ぎ見る大阪南部・富田林市東条地区にて奮闘しております。
          </Typography>{" "}
          <Typography
            className={classes.paragraph}
            gutterBottom
            paragraph={true}
          >
            化学肥料・除草剤などを使わず土壌殺菌も行わない農法を実践することにより、
            <br />
            1.栄養分が豊富な土壌となり、作物が健康に育ち、病害虫が減少。
            <br />
            2.作物と共生関係にある微生物が繁殖し、収穫量が増加。{" "}
          </Typography>{" "}
          <Typography
            className={classes.paragraph}
            gutterBottom
            paragraph={true}
          >
            そのほか、数々のメリットがありますが、何より環境に負担が少ないので、必ず未来へつながる農法であると確信しております。
          </Typography>{" "}
          <Typography
            className={classes.paragraph}
            gutterBottom
            paragraph={true}
          >
            流通・卸売を長年携ってきた弊社にとって、農業に携わることにより弊社スタッフの意識の向上は基より、みなさまへ幅広いご提案ができるよう・地域の方々との新たな流通にも取り組んでまいります。
          </Typography>{" "}
        </div>
      </div>
    </Box>
  );
}
